"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const cypress_utils_1 = require("@daytrip/cypress-utils");
const horizon_util_ts_tokens_1 = require("@daytrip/horizon-util-ts-tokens");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Breakpoint_1 = require("../utils/Breakpoint");
const transformBreakpointToCSSMediaQuery_1 = require("../utils/transformers/transformBreakpointToCSSMediaQuery");
const StyledInput = styled_components_1.default.input `
    margin-bottom: ${({ generalSpacing }) => generalSpacing};
    border-color: ${({ isValid }) => isValid !== undefined && isValid === false && horizon_util_ts_tokens_1.Colors.Red400};

    ${({ readOnly }) => readOnly &&
    (0, styled_components_1.css) `
            cursor: not-allowed;

            :focus {
                border-color: ${horizon_util_ts_tokens_1.Colors.Grey200};
            }
        `};

    ${({ mobileSpacing }) => mobileSpacing !== undefined &&
    (0, styled_components_1.css) `
            ${(0, transformBreakpointToCSSMediaQuery_1.transformBreakpointToCSSMediaQuery)(Breakpoint_1.Breakpoint.sm, "down")} {
                margin-bottom: ${mobileSpacing};
            }
        `}
`;
const Input = ({ type = "text", disabled, min, max, value, placeholder, required, readOnly, pattern, spacing, mobileSpacing, className, id, onChange, onBlur, onFocus, onKeyDown, tabIndex, isValid, autoComplete, isAutocompleteDisabled, name, inputRef, maxLength, defaultValue, ariaLabel, onPaste, ariaInvalid, ariaBusy, ariaLive, ...restProps }) => (react_1.default.createElement(StyledInput, { autoComplete: isAutocompleteDisabled ? "off" : autoComplete, generalSpacing: spacing, mobileSpacing: mobileSpacing, isValid: isValid, id: id, name: name || id, type: type, className: className, disabled: disabled, placeholder: placeholder, required: required, pattern: pattern, min: min, max: max, value: value, defaultValue: defaultValue, onChange: onChange !== undefined
        ? (event) => onChange(event.target.value)
        : undefined, onPaste: onPaste, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, tabIndex: tabIndex, readOnly: readOnly, ref: inputRef, maxLength: maxLength, "data-form-type": "other", "data-lpignore": "true", "aria-label": ariaLabel, "aria-invalid": ariaInvalid, "aria-busy": ariaBusy, "aria-live": ariaLive, ...(0, cypress_utils_1.extractCypressLocatorDataCyAttribute)(restProps) }));
exports.Input = Input;
exports.Input.displayName = "Input";
//# sourceMappingURL=Input.js.map